import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getMailQuota } from "../../../services/mailEvents";
import "./emails.css";

const fmt = (n) => new Intl.NumberFormat().format(n || 0);
const day = (date) => new Date(date).toLocaleDateString([], { day: "numeric", month: "long" });

/**
 * Remaining emails of the Mailgun plan this month, shown before a group sending, with a warning
 * when the sending would go over. `recipients`: number of emails about to be sent (optional).
 */
const MailQuotaNotice = ({ recipients }) => {
  const { t } = useTranslation();
  const [quota, setQuota] = useState(null);
  useEffect(() => {
    let alive = true;
    getMailQuota()
      .then((q) => alive && setQuota(q))
      .catch(() => alive && setQuota(null));
    return () => {
      alive = false;
    };
  }, []);

  if (!quota || quota.used === null || quota.used === undefined) return null;
  const over = quota.remaining !== null && recipients > quota.remaining;
  return (
    <p className="mail-quota-notice" data-tone={over ? "danger" : quota.percent >= 80 ? "warning" : undefined} role="status">
      <i className="ri-mail-line" aria-hidden="true"></i>
      {quota.limit
        ? t("Email quota: {{remaining}} left this month out of {{limit}} (renewed on {{date}}).", { remaining: fmt(quota.remaining), limit: fmt(quota.limit), date: day(quota.cycleEnd) })
        : t("{{used}} emails sent since {{date}} (plan limit not set: Emails sent page).", { used: fmt(quota.used), date: day(quota.cycleStart) })}
      {over && ` ${t("This sending ({{count}} emails) goes over the quota: Mailgun may refuse or bill the extra emails.", { count: recipients })}`}
    </p>
  );
};

export default MailQuotaNotice;
